import React from 'react';
import ReactDom from 'react-dom';
import { importWidgetModule as importWidgetModuleBuilder } from '@skbkontur/loader-builder';
const widgetModuleBuilderDependencies = { React, ReactDom };
export * from './types';
export function importWidgetModule({ widgetUrl, dependencies }) {
    return importWidgetModuleBuilder({
        widgetUrl,
        dependencies: {
            ...widgetModuleBuilderDependencies,
            ...dependencies,
        },
    });
}
